import React from "react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="hob-footer">
      <div className="hob-footer-top">
        <div className="hob-footer-logo">
          <span className="hob-footer-text">Spiracle Pest Worlds</span>
        </div>
        <div className="hob-footer-links">
          <span
            className="hob-footer-link"
            onClick={() => (window.location.href = "/")}
            style={{ cursor: "pointer" }}
          >
            Home
          </span>
          <span
            className="hob-footer-link"
            onClick={() => (window.location.href = "/about-us")}
            style={{ cursor: "pointer" }}
          >
            About Us
          </span>
          <span
            className="hob-footer-link"
            onClick={() => (window.location.href = "/all-services")}
            style={{ cursor: "pointer" }}
          >
            Services
          </span>
          <span
            className="hob-footer-link"
            onClick={() => (window.location.href = "/gallery")}
            style={{ cursor: "pointer" }}
          >
            Gallery
          </span>
          <span
            className="hob-footer-link"
            onClick={() => (window.location.href = "/contact-us")}
            style={{ cursor: "pointer" }}
          >
            Contact Us
          </span>
        </div>
      </div>
      <div className="hob-footer-bottom">
        <p className="hob-footer-copyright">
          © {currentYear} <a 
            href="https://100billiontech.com/ownership"
            target="_blank"
            rel="noopener noreferrer"
          >All rights reserved.</a> Designed by{" "}
          <a
            href="https://100billiontech.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            100billion Tech
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
